
import { reactive } from 'vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'

export default {
  name: 'Form',

  components: {
    HeadingLv2
  },

  setup() {
    const data = reactive<any>({
      email: '',
      password: '',
      password_confirmation: '',
      token: ''
    })

    const updateProfile = (name: string, value: string) => {
      data[name] = value
    }

    return {
      data,
      updateProfile
    }
  }
}
